"use client"

import * as React from "react"
import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"

function Accordion({ className, ...props }: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root
  className={cn("bg-card-muted rounded-lg px-6 py-1", className)}
  data-slot="accordion" {...props} />
}

function AccordionItem({ className, ...props }: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn("border-b last:border-b-0 border-background", className)}
      {...props}
    />
  )
}

function AccordionTrigger({ className, children, ...props }: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header data-slot="accordion-header">
      <AccordionPrimitive.Trigger
        className={cn(
          "flex w-full items-center justify-between py-4 text-xl font-medium transition-all cursor-pointer group",
          className
        )}
        {...props}
      >
        <span className="flex-1 text-left">{children}</span>
        <ChevronDown className="h-4 w-4 shrink-0 transition-transform duration-200 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

function AccordionContent({ className, children, ...props }: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className={cn("overflow-hidden text-sm overflow-hidden data-[state=open]:animate-[radixAccordionSlideDown_200ms_cubic-bezier(0.87,0,0.13,1)] data-[state=closed]:animate-[radixAccordionSlideUp_200ms_cubic-bezier(0.87,0,0.13,1)]", className)}
      {...props}
    >
      <div className="pt-2 pb-4">{children}</div>
    </AccordionPrimitive.Content>
  )
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
export default Accordion